import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiEnvelope } from '../../models/auth.dto';
import { ZetrixStatusResponse } from '../../models/zetrix.dto';

@Injectable({ providedIn: 'root' })
export class ZetrixService {
  private apiUrl = environment.cbdx_service.api_path;

  constructor(private http: HttpClient) {}

  status(): Observable<ApiEnvelope<ZetrixStatusResponse>> {
    return this.http.get<ApiEnvelope<ZetrixStatusResponse>>(`${this.apiUrl}/zetrix/status`);
  }
}
